import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

function Facilities() {
  const [facilities, setFacilities] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [facilitiesRes, settingsRes] = await Promise.all([
        axiosInstance.get("/api/facilities"),
        axiosInstance.get("/api/settings"),
      ]);
      setFacilities(facilitiesRes.data);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Failed to load facilities", err);
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = settings?.theme_primary_color || "#0d6efd";

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">Our Facilities</h1>
          <p className="mb-0 opacity-75">
            Everything {settings?.school_name} offers to support learning
          </p>
        </div>
      </section>

      <div className="container py-5">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : facilities.length === 0 ? (
          <p className="text-muted text-center py-5">
            Facility details coming soon.
          </p>
        ) : (
          <div className="row g-4">
            {facilities.map((f) => (
              <div className="col-12 col-sm-6 col-lg-4" key={f.id}>
                <div className="card border-0 shadow-sm h-100 text-center">
                  <div className="card-body p-4">
                    {f.icon_path ? (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${f.icon_path}`}
                        alt={f.title}
                        className="rounded-circle mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center mb-3 mx-auto"
                        style={{
                          width: "80px",
                          height: "80px",
                          backgroundColor: `${primaryColor}20`,
                        }}
                      >
                        <i
                          className="bi bi-building fs-2"
                          style={{ color: primaryColor }}
                        ></i>
                      </div>
                    )}
                    <h5 className="fw-bold">{f.title}</h5>
                    <p className="text-muted mb-0">{f.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Facilities;
